import { BoxProps } from '@mui/material'
import { FlexGrowRow } from '@xyo-network/sdk-xyo-react-js'
import React from 'react'

import { AccountHero } from '../../../../Components'
import blueCurve from '../../img/blue-curve.svg'
import mobileImage from '../../img/ps5-mobile.png'
import HeroContent from './HeroContent'

const MobileHero: React.FC<BoxProps> = (props) => {
  return (
    <AccountHero paddingBottom={2} image={blueCurve} title="New User Special Offer" {...props}>
      <HeroContent marginX={3} />
      <FlexGrowRow
        position="absolute"
        bottom={8}
        right={0}
        height="50%"
        justifyContent="flex-end"
        alignItems="flex-end"
      >
        <img src={mobileImage} width="auto" height="100%" />
      </FlexGrowRow>
    </AccountHero>
  )
}

export default MobileHero
